import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Chip,
  Divider,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Input,
  Textarea,
} from "@heroui/react"
import classes from "./ArticleForm.module.scss"
import RichTextEditor from "../../components/RichTextEditor"
import { useEffect, useMemo, useState } from "react"
import { getAllCategories } from "../../utils/requests/knowladgebase"
import { getColorByPriority, priorityMapping } from "../Tables/LeadsTable"

interface Props {
  values: Partial<KnowladgebaseArticle>
  onChange: (value: Partial<KnowladgebaseArticle>) => void
  onSubmit: React.FormEventHandler<HTMLFormElement>

  formTitle: string
  ctaLabel: string
  loading?: boolean
}
const ArticleForm = (props: Props) => {
  const { values, onChange, onSubmit, ctaLabel, loading, formTitle } = props

  const [categories, setCategories] = useState<KnowladgebaseCategory[]>([])
  useEffect(() => {
    const fetchCategories = async () => {
      const fetchedCategories = await getAllCategories()
      setCategories(fetchedCategories)
    }
    fetchCategories()
  }, [])
  const onFieldChange = (name: string, value: string) => {
    // @ts-ignore
    onChange((prevLead) => ({ ...prevLead, [name]: value }))
  }

  const selectedCategory = categories.find(
    (cat) => cat.id === Number(values.categoryId),
  )
  console.log({ selectedCategory, values: values.categoryId })
  return (
    <form onSubmit={onSubmit} className={classes.root}>
      <Card className={classes.sidebar}>
        <CardHeader>פרטים</CardHeader>
        <Divider />
        <CardBody>
          <div className={classes.form}>
            <Input
              key="title"
              type="string"
              label="כותרת"
              disabled={loading}
              value={values?.title}
              onInput={(e) => onFieldChange("title", e.currentTarget.value)}
            />

            <div className="flex items-center justify-between">
              <span>קטגוריה</span>
              <Dropdown placement="bottom-end">
                <DropdownTrigger>
                  <Chip color="default" variant="flat" size={"lg"}>
                    {selectedCategory ? selectedCategory.title : "בחר קטגוריה"}
                  </Chip>
                </DropdownTrigger>
                <DropdownMenu variant="flat">
                  {categories.map((category) => (
                    <DropdownItem
                      key={category.id}
                      onClick={() =>
                        onFieldChange("categoryId", String(category.id))
                      }
                    >
                      {category.title}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </div>
            <Input
              key="slug"
              type="string"
              label="קישור"
              disabled={loading}
              value={values?.slug}
              onInput={(e) => onFieldChange("slug", e.currentTarget.value)}
            />
            <Input
              key="groupTitle"
              type="string"
              label="כותרת קבוצה"
              disabled={loading}
              value={values?.groupTitle}
              onInput={(e) =>
                onFieldChange("groupTitle", e.currentTarget.value)
              }
            />

            <Textarea
              key="excerpt"
              type="string"
              label="תקציר"
              disabled={loading}
              value={values?.excerpt}
              onInput={(e) => onFieldChange("excerpt", e.currentTarget.value)}
            />
          </div>
        </CardBody>
        <CardFooter className={classes.footer}>
          <Button
            type="submit"
            fullWidth
            disabled={loading}
            color="success"
            variant="flat"
          >
            {ctaLabel}
          </Button>
        </CardFooter>
      </Card>
      <Card className={classes.content}>
        <CardHeader>{formTitle}</CardHeader>
        <Divider />
        <CardBody style={{ height: "100%" }}>
          <RichTextEditor
            fullHeight
            value={values?.content ?? ""}
            onChange={(text) => onFieldChange("content", text)}
          />
        </CardBody>
      </Card>
    </form>
  )
}

export default ArticleForm
